import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { ContractListComponent, PageHeaderComponent } from 'app/customer-portal/components';
import { ContractsService } from 'app/customer-portal/contracts.service';

@Component({
    selector: 'app-contract-switch-view.component.ts',
    imports: [ContractListComponent, PageHeaderComponent],
    templateUrl: './contract-switch-view.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContractSwitchViewComponent {
    protected data = toSignal(inject<ActivatedRoute>(ActivatedRoute).data);

    protected headline = computed(() => this.data().headline ?? 'Vertrag wählen');
    protected description = computed(() => this.data().description ?? 'Bitte wähle einen Vertrag:');
    protected route = computed(() => this.data().route ?? 'portal/meine-vertraege/:contractId');

    protected contracts = toSignal(inject(ContractsService).contracts$);
}
